export const DateIndonesia = (createdAt: any) => {
  const date = new Date(createdAt);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
};

export const Rupiah = (price: number) => {
  return Intl.NumberFormat("ID").format(price);
};

export const ucWords = (txt: string) => {
  if (!txt) return null;
  return txt
    .toLowerCase()
    .replace(/(?<= )[^\s]|^./g, (a: any) => a.toUpperCase());
};
